/**
 * components/branch/BranchMemberNote.js
 *
 * One line above a catalogue for a team member limited to some branches (4 Oct
 * 2026): the products are head office's, and their own branch's on/off and
 * sold out live on the Branches tab. Without it the switches on the products
 * list look broken to them (they are locked, because a change there reaches
 * every branch).
 *
 * Renders nothing for head office, for a vendor without branches and for
 * platform staff.
 *
 *   <BranchMemberNote itemsWord="dishes" onOpenBranches={() => setTab("branches")} />
 */
import React from "react";
import { AppButton } from "../ui";
import { useBranchScope } from "../../context/BranchScopeContext.js";
import { joinBranchNames } from "../../utilities/vendorScope.js";
import "./branch.css";

export const branchMemberNoteText = (names, itemsWord = "products") => {
  const where = joinBranchNames(names) || "your branch";
  return `Head office manages these ${itemsWord}. To switch one off or mark it sold out at ${where}, use the Branches tab.`;
};

export default function BranchMemberNote({ itemsWord = "products", onOpenBranches }) {
  const { isBranchScoped, hasBranches, locations } = useBranchScope();
  if (!isBranchScoped || !hasBranches) return null;
  const names = (locations || []).map((l) => l.name).filter(Boolean);
  return (
    <div className="lk-note lk-note--info lk-branch-note">
      <i className="fa fa-store" aria-hidden="true" style={{ marginTop: 2 }} />
      <span>{branchMemberNoteText(names, itemsWord)}</span>
      {typeof onOpenBranches === "function" && (
        <AppButton size="sm" variant="outline" onClick={onOpenBranches}>
          Open the Branches tab
        </AppButton>
      )}
    </div>
  );
}
